import { LOGIN, LOGOUT } from "../actions/app.js";
import {
	FETCH_COMPLETED_INSPECTIONS_BEGIN,
	FETCH_COMPLETED_INSPECTIONS_SUCCESS,
	FETCH_COMPLETED_INSPECTIONS_ERROR
} from "../actions/completed-inspections.js";

const initialState = {
	items: [],
	loading: false,
	error: null
};

export default function completedInspectionsReducer(
		state = initialState,
		action
) {
	switch (action.type) {
		case LOGIN:
			return {
				...state,
				reload: true
			};

		case LOGOUT:
			return {
				...state,
				items: []
			};

		case FETCH_COMPLETED_INSPECTIONS_BEGIN:
			return {
				...state,
				loading: true,
				error: null,
				reload: false
			};

		case FETCH_COMPLETED_INSPECTIONS_SUCCESS:
			return {
				...state,
				loading: false,
				items: action.payload,
				reload: false
			};

		case FETCH_COMPLETED_INSPECTIONS_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload.error,
				reload: false,
				items: []
			};

		default:
			return state;
	}
}
